<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" :viewBox="viewBox">
    <defs>
      <path id="close"
            d="M15.333 14L22 20.667 20.667 22 14 15.333 7.333 22 6 20.667 12.667 14 6 7.333 7.333 6 14 12.667 20.667 6 22 7.333 15.333 14z"/>
    </defs>
    <use :fill="iconColor" fill-rule="evenodd" xlink:href="#close"/>
  </svg>
</template>

<script>
import IconBase from '@/components/icons/IconBase';

export default {
  mixins: [IconBase]
}
</script>
